"use strict";

var _interopRequireDefault = require("/home/zklink/web/zklink-explorer-web-build/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _defineProperty2 = _interopRequireDefault(require("/home/zklink/web/zklink-explorer-web-build/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.function.name");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/zklink/web/zklink-explorer-web-build/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.regexp.to-string");
var _config = require("@/config");
var _ethers = require("ethers");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Unknown = 'Unknown';
var styles = [{
  layerTwoChainId: 1,
  color: 'rgba(143, 90, 232, 1)',
  style: 'chain-icon polygon-color',
  label: 'Polygon'
}, {
  layerTwoChainId: 2,
  color: 'rgba(232, 66, 67, 1)',
  style: 'chain-icon avax-color',
  label: 'AVAX'
}, {
  layerTwoChainId: 3,
  color: 'rgba(74, 78, 86, 1)',
  style: 'chain-icon bsc-color',
  label: 'Bsc'
}, {
  layerTwoChainId: 4,
  color: 'rgba(41, 138, 220, 1)',
  style: 'chain-icon goerli-color',
  label: 'Goerli'
}, {
  layerTwoChainId: 5,
  color: '#27284b',
  style: 'chain-icon zkSync-color',
  label: 'zkSync'
}, {
  layerTwoChainId: 6,
  color: '#7b5dc6',
  style: 'chain-icon Scroll-color',
  label: 'Scroll'
}, {
  layerTwoChainId: 7,
  color: '#7b5dc6',
  style: 'chain-icon Linea-color',
  label: 'Linea'
}, {
  layerTwoChainId: 9,
  color: '#4ea0ea',
  style: 'chain-icon Arbitrum-color',
  label: 'Arbitrum'
}, {
  layerTwoChainId: 10,
  color: '#eb3431',
  style: 'chain-icon Optimism-color',
  label: 'Optimism'
}, {
  layerTwoChainId: 11,
  color: '#005BFC',
  style: 'chain-icon Base-color',
  label: 'Base'
}, {
  layerTwoChainId: 12,
  color: '#73AAA4',
  style: 'chain-icon Mantle-color',
  label: 'Mantle'
}, {
  layerTwoChainId: 13,
  color: '#0496F9',
  style: 'chain-icon Manta-color',
  label: 'Manta'
}, {
  layerTwoChainId: 14,
  color: '#d63896',
  style: 'chain-icon Taiko-color',
  label: 'Taiko'
}, {
  layerTwoChainId: 15,
  color: '#fce84e',
  style: 'chain-icon opBNB-color',
  label: 'opBNB'
}, {
  layerTwoChainId: 16,
  color: '#0b0f4c',
  style: 'chain-icon StarkNet-color',
  label: 'StarkNet'
}];
var _default = {
  data: function data() {
    return {
      styles: styles,
      mainnetChainIds: [137, 43114, 56, 1, 324, 59144, 42161, 10, 8453, 5000, 204].map(function (val) {
        return "0x".concat(val.toString(16));
      })
    };
  },
  methods: {
    findNetwork: function findNetwork(value) {
      return this.networks.find(function (v) {
        return v.layerTwoChainId === value;
      }) || {
        label: Unknown,
        name: Unknown,
        style: 'chain-icon unknown-color'
      };
    },
    l1Explore: function l1Explore(value, hash) {
      var net = this.findNetwork(value);
      var url = net.explorerUrl;
      window.open("".concat(url, "/").concat(value === 16 ? 'contract' : 'address', "/").concat(hash));
    },
    l1ExploreAddress: function l1ExploreAddress(value, hash) {
      var net = this.findNetwork(value);
      var url = net.explorerUrl;
      return "".concat(url, "/").concat(value === 16 ? 'contract' : 'address', "/").concat(hash);
    },
    l1ExploreTx: function l1ExploreTx(value, hash) {
      var net = this.findNetwork(value);
      var url = net.explorerUrl;
      window.open("".concat(url, "/tx/").concat(hash));
    },
    l1ExploreTxUrl: function l1ExploreTxUrl(value, hash) {
      var net = this.findNetwork(value);
      var url = net.explorerUrl;
      return "".concat(url, "/tx/").concat(hash);
    },
    iconInfo: function iconInfo(cellValue) {
      var level = cellValue.level,
        value = cellValue.value;
      if (level === 'L1') {
        return _.find(this.networks, {
          layerTwoChainId: value
        }) || {
          label: "App".concat(value),
          name: "App".concat(value),
          style: 'chain-icon unknown-color',
          value: 100
        };
      } else {
        return _.find(_config.SUB_ACCOUNT_ID, {
          value: value
        }) || {
          label: "App".concat(value),
          name: "App".concat(value),
          style: 'chain-icon unknown-color',
          value: 100
        };
      }
    },
    showAccountDetail: function showAccountDetail() {
      var row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        level: 'L1'
      };
      if (row.level === 'L1') {
        this.l1Explore(row.value, row.hash);
      } else {
        this.$router.push("/address/".concat(row.hash));
      }
    },
    statusInfo: function statusInfo(status) {
      return _.find(_config.TRANSACTION_STATUS, {
        value: status
      }) || {
        label: Unknown,
        style: Unknown
      };
    },
    getTransactionReceiptData: function getTransactionReceiptData(val, hash) {
      var _this = this;
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var network, provider;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (hash) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return", null);
            case 2:
              network = _this.findNetwork(val);
              _context.next = 5;
              return new _ethers.providers.JsonRpcProvider(network.rpcUrl, {
                name: network.name,
                chainId: network.chainId
              });
            case 5:
              provider = _context.sent;
              _context.next = 8;
              return provider.getTransactionReceipt(hash);
            case 8:
              return _context.abrupt("return", _context.sent);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  computed: {
    networks: function networks() {
      var _this2 = this;
      try {
        var pattern = /^0x/;
        var networks = this.$store.state.network.networks || [];
        var networkList = networks.length > 0 ? networks.map(function (item) {
          return _objectSpread(_objectSpread({}, item), {}, {
            chainId: pattern.test(item.chainId) ? item.chainId : "0x".concat(item.chainId.toString(16))
          });
        }) : [];
        return networkList.filter(function (v) {
          if (_config.CHANGE_LINK === 'mainnet') {
            return _this2.mainnetChainIds.includes(v.chainId);
          } else {
            return !_this2.mainnetChainIds.includes(v.chainId);
          }
        }).map(function (network) {
          var style = _this2.styles.find(function (style) {
            return style.layerTwoChainId === network.layerTwoChainId;
          });
          return _objectSpread(_objectSpread({}, network), style);
        });
      } catch (e) {
        console.error(e, 'error');
      }
    }
  }
};
exports.default = _default;